var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23043 3.34176C5.27682 3.29533 5.3319 3.2585 5.39252 3.23337C5.45315 3.20825 5.51813 3.19531 5.58376 3.19531C5.64939 3.19531 5.71438 3.20825 5.775 3.23337C5.83563 3.2585 5.89071 3.29533 5.93709 3.34176L8.93459 6.33926C8.98102 6.38565 9.01785 6.44073 9.04298 6.50135C9.06811 6.56198 9.08104 6.62696 9.08104 6.69259C9.08104 6.75822 9.06811 6.8232 9.04298 6.88383C9.01785 6.94446 8.98102 6.99954 8.93459 7.04592L5.93709 10.0434C5.89069 10.0898 5.83561 10.1266 5.77498 10.1517C5.71436 10.1768 5.64938 10.1898 5.58376 10.1898C5.51814 10.1898 5.45317 10.1768 5.39254 10.1517C5.33192 10.1266 5.27683 10.0898 5.23043 10.0434C5.18403 9.99702 5.14723 9.94194 5.12211 9.88131C5.097 9.82069 5.08408 9.75571 5.08408 9.69009C5.08408 9.62447 5.097 9.55949 5.12211 9.49887C5.14723 9.43824 5.18403 9.38316 5.23043 9.33676L7.8746 6.69259L5.23043 4.04842C5.18401 4.00204 5.14718 3.94696 5.12205 3.88633C5.09692 3.8257 5.08398 3.76072 5.08398 3.69509C5.08398 3.62946 5.09692 3.56448 5.12205 3.50385C5.14718 3.44323 5.18401 3.38815 5.23043 3.34176Z",
    fill: "#1D1D1D",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArw);
export default __webpack_public_path__ + "static/media/right_arw.3801ecd1a96f4cb70108369c7f7aa545.svg";
export { ForwardRef as ReactComponent };